import { Component, Inject, Input, OnChanges, SimpleChanges, ViewChild, ElementRef, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpRequest, HttpEventType, HttpResponse } from "@angular/common/http";
import { AppComponent } from "../app/app.component";
import { collectExternalReferences } from "@angular/compiler";
import { timestamp, map, retry } from "rxjs/operators";
import { RequestOptions, Headers, Response, Http } from "@angular/http";
import { error } from "@angular/compiler/src/util";
import { Observable } from 'rxjs';
import { BrowserXhr } from '@angular/http';
import { style } from "@angular/animations";

@Component({
    selector: "checklist",
    template: require('./checklist.component.html'),
    styles: [require('./checklist.component.css')]
})

export class CheckListComponent implements OnChanges {

    report: CollisionReport;
    isNewCode: boolean | null;
    date: Date = new Date();

    //For File upload
    @Input() multiple: boolean = false;
    @ViewChild('fileInput') inputEl: any; //ElementRef;

    fileModel: UploadFile = <UploadFile>{};
    tempModel: StatementSuccess = <StatementSuccess>{};

    progress: number = 0;
    message: string = "";

    disclaimer1: boolean = false;
    disclaimer2: boolean = false;

    constructor(private appcomponent: AppComponent, private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private router: Router) {
        this.report = appcomponent.getReport();
        this.isNewCode = true;

        if (typeof this.report.FiveDigitCode !== "undefined") {
            this.isNewCode = false;
            this.disclaimer1 = true;
            this.disclaimer2 = true;
        }
        else
            this.report.FiveDigitCode = Number(this.uniqueIDGenerator());

        document.body.scrollTop = 0;
    }

    uniqueIDGenerator() {
        var length = 8;
        var date = this.date.getDate().toString();
        var month = this.date.getUTCMonth().toString();
        var year = this.date.getUTCFullYear().toString();
        var hour = this.date.getHours().toString();
        var minutes = this.date.getUTCMinutes().toString();
        var sec = this.date.getSeconds().toString();
        var millisec = this.date.getMilliseconds().toString();
        var reqdate = date.concat(month.concat(year.concat(hour.concat(minutes.concat(sec.concat(millisec))))));
        var ts = reqdate.toString()
        var parts = ts.split("").reverse();
        var id = "";

        for (var i = 0; i < length; ++i) {
            var index = this.getRandomInt(0, parts.length - 1);
            id += parts[index];
        }

        return id;
    }

    getRandomInt(min: any, max: any) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (typeof changes['report'] !== "undefined") {
            // retrieve the report variable change info
            var change = changes['report'];
            // only perform the task if the value has been changed
            if (!change.isFirstChange()) {
            }
        }
        else
            console.log("Undefined");
    }

    onCodeChange(value: boolean): void {
        this.isNewCode = value;
        if (!this.isNewCode) {
            this.report.FiveDigitCode = 0;
        }
        else {
            this.report.FiveDigitCode = Math.floor(Math.random() * 90000) + 10000;
        }
    }

    onBack(): void {
        this.router.navigate(["home"]);
    }

    onSubmit(): void {

        if (this.checkValidation()) {
            this.ValidateAndInitPost("email");
        }
        else {
            this.disclaimerWarning();
        }
    }

    checkValidation(): boolean {
        if (this.disclaimer1 && this.disclaimer2)
            return true;
        else
            return false;
    }

    disclaimerWarning(): void {
        var disclaimer = document.getElementById('disclaimer1')
        var disclaimer2 = document.getElementById('disclaimer2')
        var disclaimer_message = document.getElementById('disclaimer_message');

        //if (disclaimer2 != null) {
        //    disclaimer2.style.color = "#ff0000";
        //}

        //if (disclaimer != null) {
        //    disclaimer.style.color = "#ff0000";
        //}

        if (disclaimer_message != null) {
            disclaimer_message.style.display = "inline";
        }
    }

    private ValidateAndPost(page: string) {
        this.report.IsCodePageValid = true;
        this.report.CurrentPage = page;
        this.appcomponent.retriveReport(this.report.FiveDigitCode, this.report.Language);
        //GO TO NEXT PAGE
        this.router.navigate([page]);
    }

    private ValidateAndInitPost(page: string) {
        this.report.IsCodePageValid = true;
        this.report.CurrentPage = page;
        if (this.appcomponent.initReport(this.report)) {
            //GO TO NEXT PAGE
            this.router.navigate([page]);
        }
    }
}